<template>
  <div class="space-y-4">
    <div v-for="i in 3" :key="i">
      <UCard :ui="{ rounded: 'rounded-none md:rounded-lg' }" class="bg-white shadow-sm p-4">
        <!-- Üst Kısım -->
        <div class="flex justify-between items-center mb-4">
          <div class="flex items-center gap-2">
            <USkeleton class="h-5 w-24" />
            <!-- Sipariş No -->
            <USkeleton class="h-5 w-32" />
            <!-- Tarih -->
          </div>
          <USkeleton class="h-5 w-32" />
          <!-- Ödeme Durumu -->
        </div>

        <!-- Ürün Bilgisi -->
        <div class="flex items-center gap-2 mb-4">
          <USkeleton class="h-5 w-16" />
          <USkeleton class="h-5 w-16" />
          <!-- Ürün Sayısı -->
        </div>

        <!-- Toplam Tutar -->
        <div class="flex justify-between items-center mb-4">
          <USkeleton class="h-5 w-24" />
        </div>

        <!-- Sipariş Detay Butonu -->
        <div class="flex justify-center">
          <USkeleton class="h-9 w-full" />
        </div>
      </UCard>
    </div>
  </div>
</template>
